export class ExclusionPatternResourceFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isBlank",
            "baseName": "isBlank",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExclusionPatternResourceFilter.attributeTypeMap;
    }
    constructor() {
    }
}
